import { css } from '@emotion/core';
import { clearfix, media } from '@domain-group/fe-brary';
export var section = /*#__PURE__*/css("display:flex;flex-direction:column;", clearfix, " width:100%;max-width:640px;", media('>=desktop'), "{flex-direction:row;}");
export var heading = /*#__PURE__*/css(media('>=desktop'), "{width:200px;margin-bottom:0;}");
export var body = /*#__PURE__*/css("flex-grow:1;", media('>=desktop'), "{overflow:hidden;max-width:440px;}");